import React from 'react';
import LegalPageLayout from '../../components/common/LegalPageLayout';

const PrivacyPage: React.FC = () => (
  <LegalPageLayout
    title="Privacy Policy"
    updated="June 2026"
    intro="This Privacy Policy explains how Debtornator handles information collected through our website and pre-launch product demonstration (the “Demo”). Debtornator is a compliance-first debt collection platform launching Q3 2027."
    sections={[
      {
        heading: 'Information We Collect',
        body:
          'When you request access to the Demo, we collect the contact details you provide — typically your name, work email, company, and (optionally) phone number. We also collect basic, anonymized usage analytics about how the website is used.',
      },
      {
        heading: 'Demo Data Is Fictional',
        body:
          'The Demo environment contains only synthetic, fabricated records. It does not contain real consumer or debtor data, and nothing you view in the Demo relates to a real person.',
      },
      {
        heading: 'How We Use Your Information',
        body:
          'We use the contact information you provide to grant Demo access, to keep you informed about Debtornator’s development and Q3 2027 launch, and to respond to your inquiries. We do not sell your personal information.',
      },
      {
        heading: 'How We Share Information',
        body:
          'We share information only with service providers who help us operate the website and communicate with prospects, and where required by law. These providers are bound by confidentiality obligations.',
      },
      {
        heading: 'Data Security',
        body:
          'Debtornator is built around encryption of sensitive data at rest, role-based access controls, and immutable audit logging. We apply commercially reasonable safeguards to the information you provide, though no method of transmission or storage is completely secure.',
      },
      {
        heading: 'Your Choices',
        body:
          'You may ask us to access, correct, or delete the contact information you provided, or to stop contacting you, at any time by emailing privacy@debtornator.com. We will honor your request consistent with applicable law.',
      },
      {
        heading: 'Changes to This Policy',
        body:
          'We may update this Policy as the product matures toward launch. Material changes will be reflected by the “Last updated” date above.',
      },
    ]}
  />
);

export default PrivacyPage;
